module.exports = __webpack_public_path__ + "img/check-good.310b5fd7.svg";